<template>
  
    <div >
      <locationnetworkslocations
        :locationnetworkslocations="LocationNetworksLocations"
        :locationCount="locationLength"
        :loading="loading"
      ></locationnetworkslocations>
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";

import LocationNetworksLocations from '@/components/Locations/LocationNetworksLocations.vue';
export default {
  components: {
    locationnetworkslocations: LocationNetworksLocations
  },
  data() {
    return {
      allLocations: [],
      LocationNetworksLocations: [],
      loading:true,
      locationLength: 0
    };
  },
  watch: {
    '$route.query.search':{
      immediate: true,
      handler(value){
        // this.LocationNetworksLocations= await this.search(value.search)
        this.loading=true
      if(this.$route.query.search&&value!==""&&value != null){      
        // debugger
        Api()
        .get('/locations/activeFilter',{
          params: {
          search: value,
          offset: '0',
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false
          })} else if(this.$route.query.offset){
            // debugger
             Api()
        .get('/locations/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
            // this.fetchDevices()
            // // debugger
          }
      }
    },
    '$route.query.offset': {
       immediate: true,
      handler(value){
        // this.LocationNetworksLocations= await this.search(value.search)
        this.loading=true
      if(value!==""&&value != null&&this.$route.query.search&&this.$route.query.search!="" &&this.$route.query.search!== null){      
        
        Api()
        .get('/locations/activeFilter',{
          params: {
          search: this.$route.query.search,
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
      } else if(value!==""&&value != null){
        // debugger
         Api()
        .get('/locations/activeFilter',{
          params: {
          offset: this.$route.query.offset,
          records: this.$route.query.records,
         }
          })
        .then(response=>{
          this.LocationNetworksLocations=response.data.result
          this.locationLength=response.data.count
            this.loading=false})
      }
    },
  }
  },
  computed: {},
  async created() {
        this.initialize();
  },

  methods: {
    initialize() {
      this.$router.push({name: this.$route.name, query:{offset: '0', records: '20'}})
      // this.fetchLocations();
    }
  }
};
</script>

